// Constants
const {
  DOCUMENT_NIF,
  DOCUMENT_NIE,
  DOCUMENT_PASSPORT,
  DOCUMENT_OTHER,
  DOCUMENT_CC,
  DOCUMENT_PP,
  DOCUMENT_DN,
  DOCUMENT_PN,
  DOCUMENT_DA,
  DOCUMENT_PA,
} = require('../constants/documentCodes');

const {
  COUNTRY_CODE_ES,
  COUNTRY_CODE_PT,
  COUNTRY_CODE_NL,
  COUNTRY_CODE_DE,
} = require('../constants/countryCodes');

const spainDocumentTypeOptions = [
  DOCUMENT_NIF,
  DOCUMENT_NIE,
  DOCUMENT_PASSPORT,
  DOCUMENT_OTHER,
];

const portugalDocumentTypeOptions = [
  DOCUMENT_CC,
  DOCUMENT_PP,
];

const netherlandsDocumentTypeOptions = [
  DOCUMENT_PN,
  DOCUMENT_DN,
];

const germanyDocumentTypeOptions = [
  DOCUMENT_DA,
  DOCUMENT_PA,
];

const getDocumentTypes = (country) => {
  const optionMap = {
    [COUNTRY_CODE_ES]: spainDocumentTypeOptions,
    [COUNTRY_CODE_PT]: portugalDocumentTypeOptions,
    [COUNTRY_CODE_NL]: netherlandsDocumentTypeOptions,
    [COUNTRY_CODE_DE]: germanyDocumentTypeOptions,
  };
  const options = optionMap[country] || optionMap[COUNTRY_CODE_ES];
  return options;
};

const getCountryByDocumentType = (documentType) => {
  const optionMap = {
    [COUNTRY_CODE_ES]: spainDocumentTypeOptions,
    [COUNTRY_CODE_PT]: portugalDocumentTypeOptions,
    [COUNTRY_CODE_NL]: netherlandsDocumentTypeOptions,
    [COUNTRY_CODE_DE]: germanyDocumentTypeOptions,
  };
    const originCountry = Object.keys(optionMap).find(k => optionMap[k].includes(documentType));
    return originCountry;
  }

module.exports = {
  getDocumentTypes,
  getCountryByDocumentType
};
